<template>
	<div
		class="sidebar"
		:data-background-color="backgroundColor"
		:data-active-color="activeColor"
	>
		<div class="sidebar-wrapper" id="style-3">
			<div class="logo text-center">
				<a href="#" class="simple-text d-flex">
					<img class="brlogo" src="@/assets/img/logo.png" alt="" />
				</a>
				<span class="logo-site" v-if="isLoggedIn && user.isAdmin" @click="displaySites">{{ user.site }}</span>
				<span class="logo-site" v-else>{{ user.site }}</span>
			</div>
			<div v-if='showSites' class='menu'>
				<perfect-scrollbar>
					<div class='menu-item' v-for='site in sites' @click='select(site)'>{{site.sitename}}</div>
				</perfect-scrollbar>
			</div>
			<slot> </slot>
			<ul class="nav">
				<!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
				<slot name="links">
					<sidebar-link
						v-for="(link, index) in sidebarLinks"
						:key="index"
						:to="link.path"
						:name="link.name"
						:icon="link.icon"
					>
					</sidebar-link>
				</slot>
			</ul>
			<div
				v-if="isLoggedIn"
				class="logout-part d-flex justify-content-center align-items-center"
			>
				<div
					@click="logout()"
					class="icon d-flex align-items-center justify-content-center"
				>
					<span class="fa fa-user-o"></span>
				</div>
				<div class="user-name">Log out</div>
			</div>
			<moving-arrow :move-y="arrowMovePx"> </moving-arrow>
		</div>
	</div>
</template>
<script>
import MovingArrow from "./MovingArrow.vue";
import SidebarLink from "./SidebarLink";
import { mapGetters, mapActions } from "vuex";

export default {
	props: {
		title: {
			type: String,
			default: "Knowatt",
		},
		backgroundColor: {
			type: String,
			default: "black",
			validator: (value) => {
				let acceptedValues = ["white", "black", "darkblue"];
				return acceptedValues.indexOf(value) !== -1;
			},
		},
		activeColor: {
			type: String,
			default: "success",
			validator: (value) => {
				let acceptedValues = [
					"primary",
					"info",
					"success",
					"warning",
					"danger",
				];
				return acceptedValues.indexOf(value) !== -1;
			},
		},
		sidebarLinks: {
			type: Array,
			default: () => [],
		},
		autoClose: {
			type: Boolean,
			default: true,
		},
	},
	provide() {
		return {
			autoClose: this.autoClose,
			addLink: this.addLink,
			removeLink: this.removeLink,
		};
	},
	components: {
		MovingArrow,
		SidebarLink,
	},
	computed: {
		...mapGetters({
			isLoggedIn: "auth/isAuthenticated",
			user: "auth/getUser"
		}),
		/**
		 * Styles to animate the arrow near the current active sidebar link
		 * @returns {{transform: string}}
		 */
		arrowMovePx() {
			return this.linkHeight * this.activeLinkIndex;
		},
	},
	data() {
		return {
			linkHeight: 65,
			activeLinkIndex: 0,
			windowWidth: 0,
			isWindows: false,
			hasAutoHeight: false,
			links: [],
			showSites: false,
			sites: [],
		};
	},
	methods: {
		...mapActions({
			getSites: "admin/getSites",
			setUserSite: "auth/setUserSites"
		}),
		findActiveLink() {
			this.links.forEach((link, index) => {
				if (link.isActive()) {
					this.activeLinkIndex = index;
				}
			});
		},
		displaySites() {
			this.showSites= !this.showSites;
		},
		addLink(link) {
			const index = this.$slots.links.indexOf(link.$vnode);
			this.links.splice(index, 0, link);
		},
		removeLink(link) {
			const index = this.links.indexOf(link);
			if (index > -1) {
				this.links.splice(index, 1);
			}
		},
		async logout() {
			await this.$store.dispatch("auth/LogOut");
			this.$router.push("/login");
		},
		async select(site) {
			this.showSites = false;
			console.log(site)
			Object.assign(site, {userId: this.user.id});
			await this.setUserSite(site)
		}
	},
	mounted() {
		this.$watch("$route", this.findActiveLink, {
			immediate: true,
		});
	},
	async created() {
		this.sites = await this.getSites(this.user.id);
	},

};
</script>
<style lang="scss">
.ps {
  height: 80vh;
}

.menu {
  z-index: 1;
  background-color: #1e365d;
  color: #ffffff;
  position: fixed;
  width: 230px;
  border-radius: 3px;
  font-size: 16px;
  line-height:1.4;
  padding-left:10px;
  margin-left: 8px;
  font-weight: 100;
  box-shadow: 0 2px 5px rgba(255, 255, 255, 0.3);
  top: 17%;

  .menu-item {
  	font-family: 'Nunito Sans Light';
  	cursor:pointer;
  }

  .menu-item:hover {
  	background-color: #034fcb;
  }
}
.simple-text {
	align-items: center;
}
.brlogo {
	width: 65px;
	height: 65px;
	margin: 0 auto;
}
.logo-site {
	color: white;
	text-transform: uppercase;
	margin: 0 auto;
	font-size: 16px;
	font-weight:600;
	cursor: pointer;
}

.icon {
	width: 30px;
	height: 30px;
	background: #3a3a3d;
	border-radius: 50%;
	font-size: 18px;
	span {
		color: whitesmoke;
	}
}

.logout-part {
	color: white;
	margin-top: 50px;
	align-items: center;
	cursor: pointer;
	.user-name {
		font-size: 16px;
		font-weight: 400;
		padding-left: 10px;
	}
}
</style>
